import { render, staticRenderFns } from "./order-item.vue?vue&type=template&id=7c168b40&scoped=true&"
import script from "./order-item.vue?vue&type=script&lang=js&"
export * from "./order-item.vue?vue&type=script&lang=js&"
import style0 from "./order-item.vue?vue&type=style&index=0&id=7c168b40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c168b40",
  null
  
)

export default component.exports